import React, { Component } from 'react';
import ErrorMessage from '../common/ErrorMessage';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import poweredLogo from '../../img/powered-by-logo-v3.png';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withRouter } from 'react-router-dom'


const src = localStorage.logo ? localStorage.logo : `/Home/GetLogo`;
class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newPassword: '',
      passwordConfirmation: '',
      errorPassword: '',
      errorPasswordConfirmation: '',
      currentPassword: '',
      errorCurrentPassword: '',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordConfirmationChange = this.handlePasswordConfirmationChange.bind(this);
    this.handleCurrentPasswordChange = this.handleCurrentPasswordChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    const newPassword = this.state.newPassword.trim();
    const passwordConfirmation = this.state.passwordConfirmation.trim();
    const currentPassword = this.state.currentPassword.trim();

    if (!newPassword || !passwordConfirmation || !currentPassword) {
      if (!newPassword) {
        this.setState({ errorNewPassword: 'New Password Required' });
      } else {
        this.setState({ errorNewPassword: '' });
      }

      if (!passwordConfirmation) {
        this.setState({ errorPasswordConfirmation: 'Confirm Password Required' });
      } else {
        this.setState({ errorPasswordConfirmation: '' });
      }

      if (!currentPassword) {
        this.setState({ errorCurrentPassword: 'Current Password Required' });
      } else {
        this.setState({ errorCurrentPassword: '' });
      }

      return;
    } else if (newPassword !== passwordConfirmation) {
      this.setState({ errorNewPassword: 'Passwords do not match' });
      this.setState({ errorPasswordConfirmation: 'Passwords do not match' });

      return;
    } else {
      this.props.passwordRequest({ currentPassword, newPassword });
    }

    this.setState({
      newPassword: '',
      passwordConfirmation: '',
      errorNewPassword: '',
      errorPasswordConfirmation: '',
      currentPassword: '',
      errorCurrentPassword: '',
    });
  }

  handleCurrentPasswordChange(e) {
    this.setState({ currentPassword: e.target.value });
    if (this.state.errorCurrentPassword) {
      this.setState({ errorCurrentPassword: '' });
    }
  }

  handlePasswordChange(e) {
    this.setState({ newPassword: e.target.value });
    if (this.state.errorNewPassword) {
      this.setState({ errorNewPassword: '' });
    }
  }

  handleCancel(e) {
    this.props.history.goBack();
  }

  handlePasswordConfirmationChange(e) {
    this.setState({ passwordConfirmation: e.target.value });
    if (this.state.errorPasswordConfirmation) {
      this.setState({ errorPasswordConfirmation: '' });
    }
  }

  renderErrors(errors) {
    if (errors) {
      if (Array.isArray(errors)) {
        return errors.map((error, i) => <ErrorMessage key={i} error={error} />);
      } else {
        return <ErrorMessage error={errors} />;
      }
    }
  }

  render() {
    const { error, currentlySending, loading } = this.props;
    const {
      newPassword,
      errorNewPassword,
      passwordConfirmation,
      errorPasswordConfirmation,
      currentPassword,
      errorCurrentPassword,
    } = this.state;

    return (
      <div className="d-flex justify-content-center flex-column align-items-center" data-testid="change-password-page">
        <div className="col-xs-12 logo mt-4">
          <img src={src} alt="logo" height="40"/>
        </div>
        <div className="box">
          <Paper elevation={3} className="login-content-section">
            <form action="#" method="POST" onSubmit={this.handleSubmit}>
              <div className="row center-xs">
                <div className="col-xs-12">
                  <div className="box">
                    <h2 className="title mb-20">Change Password</h2>
                    <p className="sub-title mb-20">Please enter a new password</p>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    {currentlySending || loading ? (
                      <div className="current-loading">
                        <div id="loadingIndicator" data-testid="change-password-loading-indicator" className="loading-container position-relative h-100">
                          <div className="spinner-container">
                            <div className="spinner-0"></div>
                            <div className="spinner-1"></div>
                            <div className="spinner-2"></div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      this.renderErrors(error)
                    )}
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="box mb-20">
                    <FormControl
                      fullWidth
                      error={errorCurrentPassword ? true : false}
                      aria-describedby="current-password"
                    >
                      <InputLabel shrink className="los-input-label" htmlFor="current-password-label">
                        Current Password
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="current-password"
                        value={currentPassword}
                        className={`${errorCurrentPassword ? 'invalid' : ''} los-input`}
                        onChange={this.handleCurrentPasswordChange}
                        type="password"
                        inputProps={{ 'data-testid': 'change-current-password-input' }}
                      />
                      <FormHelperText className="invalid-text" id="current-password-error-text">
                        {errorCurrentPassword}
                      </FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="box mb-20">
                    <FormControl
                      fullWidth
                      error={errorNewPassword ? true : false}
                      aria-describedby="new-password"
                    >
                      <InputLabel shrink className="los-input-label" htmlFor="new-password-label">
                        New Password
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="new-password"
                        value={newPassword}
                        className={`${errorNewPassword ? 'invalid' : ''} los-input`}
                        onChange={this.handlePasswordChange}
                        type="password"
                        inputProps={{ 'data-testid': 'change-new-password-input' }}
                      />
                      <FormHelperText className="invalid-text" id="password-error-text">{errorNewPassword}</FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="box mb-20">
                    <FormControl
                      fullWidth
                      error={errorPasswordConfirmation ? true : false}
                      aria-describedby="password-confirmation"
                    >
                      <InputLabel shrink className="los-input-label" htmlFor="password-confirmation-label">
                        Confirm Password
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="password-confirmation"
                        value={passwordConfirmation}
                        className={`${errorPasswordConfirmation ? 'invalid' : ''} los-input`}
                        onChange={this.handlePasswordConfirmationChange}
                        type="password"
                        inputProps={{ 'data-testid': 'change-confirm-password-input' }}
                      />
                      <FormHelperText className="invalid-text" id="password-error-text">
                        {errorPasswordConfirmation}
                      </FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box pt-1">
                    <Button
                      variant="contained"
                      type="submit"
                      id="submit-button"
                      disableRipple
                      className="los-btn los-btn-primary shadow-none text-capitalize"
                      color="primary"
                      disabled={currentlySending || loading ? true : false}
                      data-testid="change-password-submit-button"
                    >
                      Submit
                    </Button>
                    <Button
                      variant="contained"
                      id="cancel-button"
                      disableRipple
                      className="los-btn los-btn-primary shadow-none text-capitalize ms-3"
                      color="primary"
                      onClick={this.handleCancel}
                      data-testid="change-password-cancel-button"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          </Paper>
          <a href="http://defisolutions.com" className="powered-img mb-5" target="_blank" rel="noopener noreferrer" data-testid="change-password-powered-by-link">
            <img src={poweredLogo} alt="logo" />
          </a>
        </div>
      </div>
    );
  }
}

export default withRouter(ChangePassword);
